import react, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";

import { Paper, Grid, TextField, CardContent, Button, CircularProgress } from '@mui/material';
import { Checkbox, Snackbar } from '@mui/material';

import AuthContext from '../../context/AuthContext';

import { Alert } from '@mui/material';
import TextInput from '../../common/TextInput';

const Login = (props) => {

  let navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    
    if (!email.trim() || !password.trim()) {
      setError('Please enter both email and password');
      return;
    }

    setError('');

    try {
      await authCtx.login(email, password);
      // If login is successful, navigate to overview
      navigate('/overview');
    } catch (error) {
      setError(error.message || 'Login failed. Please try again.');
    }
  }

  function keyDown(e, textField) {
    if (textField === "password") {
      if (e.code === "Enter") {
        submit(e);
      }
    } else {
      if (e.code === "Enter") {
        document.getElementById("password").focus();
      }
    }
  }

  function changeEmail(event) {
    setEmail(event.target.value);
    if (error) setError(''); // Clear error when user starts typing
  }

  function changePassword(event) {
    setPassword(event.target.value);
    if (error) setError(''); // Clear error when user starts typing
  }

  const paperStyle = { padding: 20, width: 580, margin: "0 auto", backgroundColor: "transparent" }
  
  return (
    <div className="login-register-page">
      <div className="login">
        <Paper elevation={0} style={paperStyle}>
          <CardContent>
            <div className="form-heading">LOGIN</div>
            <div className="form-wrapper">
              <form>
                <TextInput 
                  type="email" 
                  label='Email' 
                  onChange={changeEmail} 
                  value={email} 
                  placeholder="Email Address" 
                  onKeyDown={(e) => keyDown(e, "email")} 
                  className='textbox'
                  disabled={authCtx.loginInProgress}
                />
                <TextInput 
                  label='Password' 
                  onChange={changePassword} 
                  value={password} 
                  type="password" 
                  placeholder="Password" 
                  onKeyDown={(e) => keyDown(e, "password")} 
                  required 
                  className='textbox'
                  disabled={authCtx.loginInProgress}
                />
                <button 
                  disabled={authCtx.loginInProgress} 
                  className="btn-primary w-100 mtb-1rem" 
                  onClick={submit}
                >
                  {authCtx.loginInProgress ? <CircularProgress size={22} style={{color: "#fff"}} /> : "Login"}
                </button>
              </form>
            </div>
            {error && (
              <Snackbar 
                open={!!error} 
                autoHideDuration={5000} 
                onClose={() => setError('')}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert severity="error" onClose={() => setError('')}>
                  {error}
                </Alert>
              </Snackbar>
            )}
          </CardContent>
        </Paper>
      </div>
    </div>
  );
}

export default Login;









